/*
 * TutorialOptionForm Messages
 *
 * This contains all the text for the TutorialOptionForm component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages/TutorialDetailsPage/components/TutorialOptionForm';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Possible values (options)',
  },
  codeColumnLabel: {
    id: `${scope}.codeColumnLabel`,
    defaultMessage: 'Code',
  },
  textEnColumnLabel: {
    id: `${scope}.textEnColumnLabel`,
    defaultMessage: 'Text EN',
  },
  textDeColumnLabel: {
    id: `${scope}.textDeColumnLabel`,
    defaultMessage: 'Text DE',
  },
  visibleColumnLabel: {
    id: `${scope}.visibleColumnLabel`,
    defaultMessage: 'Visible',
  },
  correctColumnLabel: {
    id: `${scope}.correctColumnLabel`,
    defaultMessage: 'Correct',
  },
  optionsAreaLabel: {
    id: `${scope}.optionsAreaLabel`,
    defaultMessage: 'Possible values (options)',
  },
  deleteOptionConfirmMessage: {
    id: `${scope}.deleteOptionConfirmMessage`,
    defaultMessage:
      'Are you sure you want to delete this possible value (option)?',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage: 'Delete',
  },
  editTooltip: {
    id: `${scope}.editTooltip`,
    defaultMessage: 'Edit',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  addButton: {
    id: `${scope}.addButton`,
    defaultMessage: 'Add',
  },
});
